// @flow
import React, { Component, Fragment } from 'react'
import $ from 'jquery'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

const Panel = styled.div`
  background: #f2f2f2;
  border-top: 1px solid #bdbdbd;
  padding: 5px 0;
  width: 100%;
  z-index: 10;
  ${({ fixed }: Object) => (fixed ? 'position: fixed; bottom: 0;' : '')};
`

type Props = {|
  children: any
|}

type State = {|
  isPanelFloat: boolean,
  panelDummyHeight: number
|}

export default class FloatPanel extends Component<Props, State> {
  panelElement: any
  scrolledHandler: Function

  constructor(props: Props) {
    super(props)

    this.panelElement = document.createElement('div')
    document.body && document.body.appendChild(this.panelElement)

    this.state = { isPanelFloat: false, panelDummyHeight: 0 }

    this.scrolledHandler = () => this.scrolled()

    $(window).on('scroll', this.scrolledHandler)
    $(window).on('resize', this.scrolledHandler)
  }

  render() {
    return createPortal(this.renderPanel(), this.panelElement)
  }

  componentDidMount() {
    this.scrolled()
  }

  componentWillUnmount() {
    $(window).off('scroll', this.scrolledHandler)
    $(window).off('resize', this.scrolledHandler)
  }

  scrolled() {
    let panel = $(this.panelElement)
    const isPanelFloat =
      panel.offset().top + panel.height() > $(window).scrollTop() + $(window).height()
    const panelDummyHeight = isPanelFloat ? panel.height() : 0

    this.setState({ isPanelFloat, panelDummyHeight })
  }

  renderPanel() {
    return (
      <Fragment>
        <div style={{ height: this.state.panelDummyHeight }} />
        <Panel fixed={this.state.isPanelFloat}>{this.props.children}</Panel>
      </Fragment>
    )
  }
}
